module.exports = __webpack_public_path__ + "img/certificate8.3a7cb5f6.jpg";